import React, { ReactNode } from 'react'

import { Alert } from '../types'
import AlertsToaster from '../components/alerts/floating-alert'

/**
 * Provider for global notifications, alerts, errors.
 * They will be shown by a Floating Toast component.
 */

const initialState : { alerts: Alert[], addAlert: any } = { alerts: [], addAlert: () => {} } 
const AlertsContext = React.createContext(initialState)

const AlertsProvider = ({ children }: { children: ReactNode }) => {
    const [alerts, setAlerts] = React.useState(initialState.alerts)
    const addAlert = React.useCallback((alert: Alert) => {
        const newAlert = { ...alert, id: Date.now() + Math.random() }
        setAlerts((prevAlerts: Alert[]) => [...prevAlerts, newAlert])
        // delete alert after 3 seconds
        setTimeout(() => {
            setAlerts((prevAlerts: Alert[]) => prevAlerts.filter((a: Alert) => a.id !== newAlert.id))
        }, 3000)
    }, [])

    const alertsContextValue = React.useMemo(() => ({ alerts, addAlert }), [alerts, addAlert])
    return (
        <AlertsContext.Provider value={alertsContextValue}>
            {children}
            <AlertsToaster />
        </AlertsContext.Provider>
    )
}

export const useAlerts = () => React.useContext(AlertsContext)
export default AlertsProvider